import React from 'react';
import { FileCheck, Home, Layers, FileText, PenTool, Ruler } from 'lucide-react';
import { services } from '../mock';

const iconMap = {
  FileCheck,
  Home,
  Layers,
  FileText,
  PenTool,
  Ruler
};

const Services = () => {
  return (
    <section id="services" className="py-20 px-4 bg-white">
      <div className="container mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-4" style={{ color: '#1e3a5f' }}>
            Serviços Oferecidos
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Soluções completas para regularização imobiliária e projetos de engenharia
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service) => {
            const IconComponent = iconMap[service.icon];
            return (
              <div
                key={service.id}
                className="group p-8 bg-white rounded-xl border-2 border-gray-200 hover:border-[#1e3a5f] transition-all duration-300 hover:shadow-xl"
              >
                <div
                  className="w-16 h-16 rounded-lg flex items-center justify-center mb-6 transition-colors duration-300"
                  style={{ backgroundColor: '#f8f9fa' }}
                >
                  <IconComponent
                    className="w-8 h-8 transition-colors duration-300"
                    style={{ color: '#c17835' }}
                  />
                </div>
                <h3 className="text-xl font-bold mb-3" style={{ color: '#1e3a5f' }}>
                  {service.title}
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  {service.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;